// Mock data for Massimo Home Improvement website

export const services = [
  {
    id: 1,
    title: "Residential",
    description: "Transform your living spaces into the home you've always dreamed of. From modern kitchens to luxurious bathrooms, we bring your vision to life with exceptional craftsmanship and attention to detail.",
    features: [
      "Custom design tailored to your lifestyle",
      "Premium materials and finishes",
      "Complete project management",
      "Quality guaranteed"
    ],
    gallery: [
      "https://images.unsplash.com/photo-1760546120487-ccb54df9838c",
      "https://images.unsplash.com/photo-1628745277862-bc0b2d68c50c",
      "https://images.unsplash.com/photo-1763485955499-f11dcfdda823",
      "https://images.pexels.com/photos/3926542/pexels-photo-3926542.jpeg"
    ]
  },
  {
    id: 2,
    title: "Commercial",
    description: "Elevate your business environment with professional renovations that enhance productivity and impress clients. We specialize in office spaces, retail stores, and commercial facilities with minimal operational disruption.",
    features: [
      "Corporate-focused design",
      "Flexible scheduling",
      "Minimal downtime",
      "Professional finishes"
    ],
    gallery: [
      "https://images.unsplash.com/photo-1497366754035-f200968a6e72?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwyfHxjb21tZXJjaWFsJTIwc3BhY2V8ZW58MHx8fHwxNzczMzY1NzE0fDA&ixlib=rb-4.1.0&q=85",
      "https://images.unsplash.com/photo-1718220216044-006f43e3a9b1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwzfHxjb21tZXJjaWFsJTIwc3BhY2V8ZW58MHx8fHwxNzczMzY1NzE0fDA&ixlib=rb-4.1.0&q=85",
      "https://images.unsplash.com/photo-1631193908297-ebadbad17167?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwzfHxvZmZpY2UlMjByZW5vdmF0aW9ufGVufDB8fHx8MTc3MzM2NTcxMXww&ixlib=rb-4.1.0&q=85",
      "https://images.unsplash.com/photo-1677272272629-67d6edf3ea81?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwyfHxvZmZpY2UlMjByZW5vdmF0aW9ufGVufDB8fHx8MTc3MzM2NTcxMXww&ixlib=rb-4.1.0&q=85"
    ]
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Johnson",
    role: "Homeowner",
    content: "Massimo completely transformed our kitchen. The quality of work exceeded our expectations! Their professionalism and attention to detail are exceptional.",
    rating: 5
  },
  {
    id: 2,
    name: "Michael Davis",
    role: "Business Owner",
    content: "Outstanding renovation of our office space. The team was extremely professional and met all deadlines perfectly.",
    rating: 5
  },
  {
    id: 3,
    name: "Emily Roberts",
    role: "Homeowner",
    content: "From planning to execution, everything was perfect. I highly recommend Massimo for anyone seeking quality and reliability.",
    rating: 5
  }
];

export const companyInfo = {
  name: "Massimo Home Improvement",
  tagline: "Elevate Your Projects and Dreams to Massimo",
  description: "We are specialists in residential and commercial renovations, offering complete solutions from planning to final execution. With experience in the market, our team of qualified professionals is ready to transform your spaces with quality, design, and high-standard finishes.",
  mission: "To transform spaces through high-quality renovations, exceeding our clients' expectations with professionalism, creativity, and commitment.",
  values: [
    "Uncompromising Quality",
    "Transparency and Honesty",
    "Commitment to Deadlines",
    "Excellence in Finishes",
    "Customer Satisfaction"
  ],
  stats: [
    { number: "50+", label: "Projects Completed" },
    { number: "12+", label: "Years of Experience" },
    { number: "98%", label: "Satisfied Clients" },
    { number: "30+", label: "Qualified Professionals" }
  ],
  contact: {
    phone: "(678) 879-7117",
    email: "info@massimohomeimprovement.com",
    address: "Atlanta, GA",
    hours: "Mon - Fri: 8am to 6pm | Sat: 9am to 1pm"
  },
  social: {
    instagram: "https://www.instagram.com/MassimoConstructionUSA",
    facebook: "https://www.facebook.com/massimohomeimprovement",
    x: "https://x.com/MassimohomeUS"
  }
};

export const heroContent = {
  title: "Elevate Your Projects and Dreams to Massimo",
  subtitle: "High-quality residential and commercial renovations with sophisticated design and impeccable finishes",
  cta: "Schedule Consultation",
  image: "https://images.unsplash.com/photo-1762811054950-b74e0a055c80?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBob21lJTIwcmVub3ZhdGlvbnxlbnwwfHx8fDE3NzMzNTgwNDF8MA&ixlib=rb-4.1.0&q=85"
};

export const aboutImages = [
  "https://images.unsplash.com/photo-1702392183172-17fdef8002b4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBjb250cmFjdG9yJTIwcmVub3ZhdGlvbnxlbnwwfHx8fDE3NzMzNTgwOTF8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1763973137261-f6c67c5d3051?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwyfHxyZW5vdmF0aW9uJTIwdGVhbSUyMHdvcmt8ZW58MHx8fHwxNzczMzU4MDk1fDA&ixlib=rb-4.1.0&q=85"
];
